import * as React from 'react';
import { connect } from 'react-redux';
import { fetchSeller, editSeller } from '../../actions/sellersActions';
import BigSpinner from '../General/BigSpinner';
import { toast } from 'react-toastify';
import { filtroHoy } from '../../utilities/fechasFiltro';
const fechaFiltroHoy = filtroHoy();

class BannerTienda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nuevoCDN: null,
            cdnEliminado: null,
            seller: null,
        };
    }

    componentDidMount() {
        const { seller } = this.props;

        // Si viene seller.cdn, agregamos eliminado:false; si no, dejamos array vacío
        const sellerConEliminado = {
            ...seller,
            cdn: (seller.cdn || []).map(c => ({
                ...c,
                eliminado: c.eliminado ?? false
            }))
        };

        this.setState({
            seller: sellerConEliminado
        });
    }

    agregarFila = () => {
        const cdn = Array.isArray(this.props.seller.cdn) ? [...this.props.seller.cdn] : [];

        if (cdn?.length > 0) {
            const ultimaFila = cdn[cdn?.length - 1];
            const filaLlena = Object.values(ultimaFila).some(valor => valor !== 0 && valor !== "");

            if (!filaLlena) {
                toast.error("Debe llenar al menos un valor en la última fila antes de agregar otra.");
                return;
            }
        }

        const nuevoCdn = [
            ...cdn,
            {
                idSeller: null,
                descripcion: "",
                urlDescktop: "",
                urlMovile: "",
                vigenciaDesde: fechaFiltroHoy,
                vigenciaHasta: fechaFiltroHoy,
                linkRedireccion: "",
            }
        ];

        this.props.editSeller({
            ...this.props.seller,
            cdn: nuevoCdn
        });
    }

    changeCDN = (event, index) => {
        const { name, type, value, checked } = event.target;
        const cdnActualizado = [...(this.props.seller?.cdn || [])];

        // Busco solo los visibles (sin eliminado)
        const visibles = cdnActualizado.filter(c => !c.eliminado);
        const cdnIndexReal = this.getRealIndex(visibles, cdnActualizado, index);

        cdnActualizado[cdnIndexReal] = {
            ...cdnActualizado[cdnIndexReal],
            [name]: type === 'checkbox' ? checked : value
        };

        this.props.editSeller({
            ...this.props.seller,
            cdn: cdnActualizado
        });
    }

    eliminarCDN = (index) => {
        const seller = { ...this.props.seller };
        const cdn = seller.cdn.filter(c => !c.eliminado)[index];
        const realIndex = seller.cdn.findIndex(c => c === cdn);

        let cdnsActualizados;

        if (cdn.id) {
            cdnsActualizados = seller.cdn.map((item, i) => {
                if (i === realIndex) {
                    return { ...item, eliminado: true };
                }
                return item;
            });
        } else {
            cdnsActualizados = seller.cdn.filter((_, i) => i !== realIndex);
        }

        this.props.editSeller({
            ...seller,
            cdn: cdnsActualizados,
        });

        toast.success('CDN eliminado, no olvide guardar los cambios ');
    }

    getRealIndex = (visibles, originales, indexVisible) => {
        const itemVisible = visibles[indexVisible];
        return originales.findIndex(c => c === itemVisible);
    }

    render() {
        const { isLoadingSellers, seller } = this.props;
        let cdns = (seller.cdn || []).filter(cdn => !cdn.eliminado);

        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="card-body">
                    <div className="row">
                        {isLoadingSellers ?
                            <BigSpinner />
                            : (
                                <div className="col-12 table-responsive">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">Descripción</th>
                                                <th scope="col">UrlDesktop</th>
                                                <th scope="col">UrlMovile</th>
                                                <th scope="col">Vigencia Desde</th>
                                                <th scope="col">Vigencia Hasta</th>
                                                <th scope="col">Link Redirección</th>
                                                <th>
                                                    <i
                                                        className="fas fa-plus"
                                                        onClick={this.agregarFila}
                                                        style={{ cursor: 'pointer' }}
                                                        title="Agregar CDN a la lista"
                                                    />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cdns.map((cdn, index) => (
                                                <tr className="hover-background-color" key={index}>
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            name="descripcion"
                                                            value={cdn.descripcion || ""}
                                                            onChange={(e) => this.changeCDN(e, index)}
                                                        />
                                                    </td>

                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            name="urlDescktop"
                                                            value={cdn.urlDescktop || ""}
                                                            onChange={(e) => this.changeCDN(e, index)}
                                                        />
                                                    </td>

                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            name="urlMovile"
                                                            value={cdn.urlMovile || ""}
                                                            onChange={(e) => this.changeCDN(e, index)}
                                                        />
                                                    </td>

                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="date"
                                                            name="vigenciaDesde"
                                                            value={cdn.vigenciaDesde?.substring(0, 10)}
                                                            onChange={(e) => this.changeCDN(e, index)}
                                                            disabled={cdn.id != null}
                                                            style={cdn.id != null ? { backgroundColor: '#f5f5f5', color: '#888' } : {}}
                                                        />
                                                    </td>
                                                    
                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            type="date"
                                                            name="vigenciaHasta"
                                                            value={cdn.vigenciaHasta?.substring(0, 10)}
                                                            onChange={(e) => this.changeCDN(e, index)}
                                                            disabled={cdn.id != null}
                                                            style={cdn.id != null ? { backgroundColor: '#f5f5f5', color: '#888' } : {}}
                                                        />
                                                    </td>

                                                    <td>
                                                        <input
                                                            className="form-control"
                                                            name="linkRedireccion"
                                                            value={cdn.linkRedireccion || ""}
                                                            onChange={(e) => this.changeCDN(e, index)}
                                                        />
                                                    </td>

                                                    <td>
                                                        <i
                                                            className="fas fa-trash-alt"
                                                            onClick={() => this.eliminarCDN(index)}
                                                            style={{ cursor: 'pointer' }}
                                                            title="Eliminar CDN"
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    seller: JSON.stringify(state.general.generalObject) !== "{}"
        ? state.general.generalObject
        : state.sellers.seller,
    tipoUsuario: state.general.tipoUsuario,
    isLoadingSellers: state.sellers.loadingSellers,
    sellers: state.sellers.sellers,
});

export default connect(mapStateToProps, { fetchSeller, editSeller })(BannerTienda);